<template>
  <tr>
    <template v-if="header">
      <td class="nosort">Account Name</td>
      <td class="nosort">Program Name</td>
      <td class="nosort">Year</td>
      <td class="violations nosort">Violations</td>
    </template>
    <template v-else-if="violation">
      <td class="account-name">
        <div class="account-name">
          <router-link
            :to="`/account/${violation.accountID}/policy-detail`"
            data-test="account-name"
            :title="violation.accountName"
          >
            {{ violation.accountName?.substring(0, 30) }}
          </router-link>
        </div>
      </td>
      <td class="program-name">{{ violation.programName }}</td>
      <td class="program-year">{{ violation.programYear }}</td>
      <td class="violations">
        <div class="rule-container inline-flex" v-for="(rule, index) in violatedRules(violation)" :key="index">
          <Tooltip
            v-if="rule.violated"
            position="bottom"
            :text="`Rule: ${rule.desc} — Resolution: ${rule.resolution}`">
            <span
              class="flex bg-primary w-5 h-5 text-white mr-0.5 rounded-full text-[10pt] font-bold justify-center items-center scale-[85%]">
              <span class="w-fit h-fit font-mono">{{ rule.value }}
              </span>
            </span>
          </Tooltip>
        </div>
      </td>
    </template>
  </tr>
</template>

<script setup lang="ts">
import { DataQualityProgram, DataQualityRule } from '@/types/DataQuality';
import Tooltip from '@/components/v2/Tooltip.vue';

const props = defineProps<{
  header?: boolean,
  violation?: DataQualityProgram,
  rules?: Readonly<DataQualityRule[]>,
}>();

function violatedRules(policy: DataQualityProgram) {
  if (!props.rules) return [];
  return props.rules.map((r, i) => ({ ...r, violated: Reflect.get(policy, 'rule' + (i + 1)) })) as (DataQualityRule & {
    violated: boolean
  })[];
}
</script>
